import * as Yup from 'yup';
import { useTranslation } from '../../../hooks/useTranslation';

type TFunction = ReturnType<typeof useTranslation>['t'];

export const ADD_EDIT_DOCUMENT_SCHEMA = (t: TFunction) => {
    return Yup.object().shape({
        name: Yup.string()
            .trim()
            .required(t('validationMessages.ADD_EDIT_DOCUMENT_SCHEMA.name.required'))
            .max(1024, t('validationMessages.ADD_EDIT_DOCUMENT_SCHEMA.name.max')),
        description: Yup.string().trim().max(255, t('validationMessages.ADD_EDIT_DOCUMENT_SCHEMA.description.max')),
    });
};
